import { CheckedAddress, NormalizedNumber } from '@sparkdotfi/common-universal'
import { zeroAddress } from 'viem'

import { PermitAction } from '../types'
import { Token } from '@/domain/types/Token'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { assets } from '@/ui/assets'

export function getFakePermitAction(): PermitAction {
  return {
    type: 'permit',
    token: new Token({
      address: CheckedAddress(zeroAddress),
      symbol: TokenSymbol('FAKE'),
      name: 'Fake',
      decimals: 18,
      unitPriceUsd: NormalizedNumber('1'),
      logo: assets.token.unknown,
    }),
    spender: CheckedAddress(zeroAddress),
    value: NormalizedNumber.ZERO,
  }
}
